<template>
  <el-form :model="uInfo" :rules="rules" ref="loginForm" label-position="top">
    <el-form-item :label="$t('message.home.username')" prop="username">
      <el-input v-model="uInfo.username" :placeholder="$t('message.home.pleaseEnterUsername')"
        @keyup.enter.native="loginEvent"></el-input>
    </el-form-item>
    <el-form-item :label="$t('message.home.password')" prop="password">
      <el-input v-model="uInfo.password" :type="showPassword ? 'password' : 'text'"
        :placeholder="$t('message.home.pleaseEnterPassword')" @keyup.enter.native="loginEvent">
        <template slot="suffix">
          <img class="password-icon" :src="showPassword ? imageMap.close : imageMap.open"
            @click="showPassword = !showPassword" />
        </template>
      </el-input>
    </el-form-item>

    <el-form-item prop="code" :label="$t('message.home.verificationCode')" >
      <el-row :span="24">
        <el-col :span="16">
          <el-input size="small" @keyup.enter.native="handleLogin" :maxlength="code.len" v-model="uInfo.code"
            :placeholder="$t('message.home.pleaseEnterVerificationCode')">
            <i slot="prefix" class="icon-yanzhengma"></i>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <!-- <span class="login-code-img"
                  @click="refreshCode"
                  v-if="code.type == 'text'">{{code.value}}</span> -->
            <img :src="code.src" class="login-code-img" @click="refreshCode" />
            <!-- <i class="icon-shuaxin login-code-icon" @click="refreshCode"></i> -->
          </div>
        </el-col>
      </el-row>

    </el-form-item>


    <div style="display: flex; justify-content: space-between; margin-top: 25px">
      <p class="tips">
        {{ $t("message.home.noAccount") }}
        <span @click="goRegister">{{ $t("message.home.signUp") }}</span>
      </p>
      <!-- <span class="forgot-password" @click="openService">
        {{ $t("message.home.ForgotPassword") }}
      </span> -->
    </div>
    <el-form-item>
      <el-button class="sing-in-btn" type="primary" :loading="loading" @click="vueLogin">
        {{ $t("message.home.signIn") }}
      </el-button>
    </el-form-item>
    <EsOnlineServiceView v-model="showOnlieService" />
    <!-- <Vcode
      :imgs="[img1, img2, img3, img4, img5]"
      :show="showVcoe"
      @success="onVCodeSuccess"
      :canvasHeight="200"
      @close="showVcoe = false"
      :sliderText="$t('message.home.滑动验证')"
      :successText="$t('message.home.vcodePass')"
      :failText="$t('message.home.vcodeFail')"
    /> -->
  </el-form>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
// import Vcode from "vue-puzzle-vcode";
import common from "@/util/common";
import { BIZ_MESSAGE_LAST_ID } from "@/common";

///////////////////////////////////////////////////////////////////////


// import {
// 		index
// 	} from "@/api/upms/login.js"
// import {
// 	LoginByUsername
// } from '@/api/user.js'
// import {
// 	getStore,
// 	setStore
// } from '@/utils/store.js'
// import {
// 	isURL
// } from '@/utils/validate.js'
import {
  // getUserInfo,
  // loginByPhone,
  // loginByThirdParty,
  loginByUsername,
  // logout,
  // refreshToken
} from '@/api/login.js'
import {
  randomLenNum,
  encryption
} from '@/util/util.js'
import { navigateAfterLogin } from '@/util/shopAuth'
import {
  securityKey
} from '@/config/index.js'
import request from "@/util/http";


///////////////////////////////////////////////////////////////////////



export default {
  name: "EsAccountForm",
  components: {
    // Vcode,
  },
  data() {
    return {
      loading: false,
      itemname: process.env.VUE_APP_ITEM_NAME,
      loginModel: {
        username: "",
        password: "",
      },
      showPassword: true,
      showVcoe: false,
      img1: require("@/assets/image/slider/1.png"),
      img2: require("@/assets/image/slider/2.png"),
      img3: require("@/assets/image/slider/3.png"),
      img4: require("@/assets/image/slider/4.png"),
      img5: require("@/assets/image/slider/5.png"),
      imageMap: {
        open: require("@/assets/image/eye-open.png"),
        close: require("@/assets/image/eye-close.png"),
      },
      rules: {
        username: [
          common.ruleUtils.getRule("required", this.$t("message.home.pleaseEnterUsername")),
        ],
        password: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.pleaseEnterPassword")
          ),
          common.ruleUtils.getRule("password"),
        ],
      },
      showOnlieService: false,
      onlinePath: "",



      ////////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      username: "",
      password: "",
      code: {
        src: "/code",
        value: "",
        len: 4,
        type: "text"
      },
      objsList: [],
      userInfo: {},
      orderInfo: {},
      loadingHidden: false,
      uInfo: {
        username: "BizSpring",
        password: "111111",
        code: "",
        randomStr: "",
      },

      // rules: {

      // 	username: {
      // 		rules: [{
      // 			required: true,
      // 			errorMessage: app.globalData.messages['Member_username']+' '+app.globalData.messages['common_notNull']
      // 		}]
      // 	},
      // 	password: {
      // 		rules: [{
      // 			required: true,
      // 			errorMessage: app.globalData.messages['Member_password']+' '+app.globalData.messages['common_notNull']
      // 		}]
      // 	},
      // 	code: {
      // 		rules: [{
      // 			required: true,
      // 			errorMessage: app.globalData.messages['common_captcha_name']+' '+app.globalData.messages['common_notNull']
      // 		}]
      // 	},
      // },

      ///////////////////////////////////////////////////////////////////////




    };
  },
  mounted(){
    this.refreshCode();
  },
  activated() {
    this.refreshCode();
  },
  methods: {
    ...mapMutations({ setToken: "SETTOKEN", setHanders: "SETHANDERS" }),
    ...mapActions(["getUserInfo", "applyMemberLanguagePreference"]),
    loginEvent() {

      if (this.itemname == 'Hive') {
        this.onVCodeSuccess()
      } else {
        this.showVcoe = true;
      }

    },
    openService() {
      if (this.onlinePath) {
        window.open(
          this.onlinePath,
          "_blank"
        );
      } else {
        this.showOnlieService = true;
      }
    },
    async getOnlinePath() {
      // let res = await apiGetCustomerService({ code: 'customer_service_url' });
      // this.onlinePath = res.data.customer_service_url
    },
    onVCodeSuccess() {
      this.showVcoe = false;
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const loginResult = await loginApi({
              username: this.loginModel.username,
              password: encodeURIComponent(this.loginModel.password),
            });
            localStorage.setItem(BIZ_MESSAGE_LAST_ID, "");
            this.setToken(loginResult.data.token);
            await this.getUserInfo(loginResult.data);

            this.$message({
              message: this.$t(
                "message.home.loginSuccess" /**添加到购物车成功 */
              ),
              type: "success",
            });
            this.$refs.loginForm.resetFields();
            const langChanged = await this.applyMemberLanguagePreference();
            if (!langChanged) {
              navigateAfterLogin(this);
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },


    refreshCode() {
      this.uInfo.code = ''
      this.uInfo.randomStr = randomLenNum(this.code.len, true)
      this.code.value = randomLenNum(this.code.len);
      this.code.src = this.publicGlobalUrl+'/code?randomStr=' + this.uInfo.randomStr
    },

    vueLogin: function () {
      var that = this;
      const user = encryption({
        data: that.uInfo,
        key: securityKey,
        param: ['password']
      });
      this.loading = true;
      loginByUsername(user.username, user.password, user.code, user.randomStr).then(
        async response => {
          if (response.data.user) {
            this.$store.commit("SETUSERINFO", response.data.user);
            let handerData = {
              'authorization': 'Bearer ' + response.data.access_token,
              'userId': response.data.user.id,
              'username': response.data.user.username
            }
            this.setHanders(handerData)
            localStorage.setItem(BIZ_MESSAGE_LAST_ID, "");
            this.setToken(response.data.access_token);
            localStorage.setItem('BIZ_TOKEN', response.data.access_token);
            this.$refs.loginForm.resetFields();
            this.$message.success(this.$t('message.home.loginSuccess'));
            const langChanged = await this.applyMemberLanguagePreference();
            if (!langChanged) {
              navigateAfterLogin(this);
            }
          } else {
            this.refreshCode();
          }
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          this.refreshCode();
          this.$message.error(this.$t('message.home.loginFail') || 'Login failed');
        })
    },



    goRegister() {
      this.$router.push("/register");
    },
  },
};
</script>
<style scoped lang="scss">
html[dir="rtl"] {
  .el-form-item v::deep .el-form-item__error {
    right: 0;
    left: auto;
  }

  .vue-puzzle-vcode {
    direction: ltr;
  }
}

v::deep .range-text {
  padding-left: 40px;
}


.login-container {
  width: 100%;
  margin: 0 auto;
}

.login-weaper {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 500px;
  margin-top: -200px;
}

.login-container::before {
  z-index: -1024;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url("/img/login.png");
  background-size: cover;
}

.login-left {
  float: left;
  width: 50%;
  position: relative;
}

.login-logo {
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 150px;
  font-size: 24px;
  color: #333;
  margin-left: 120px;
}

.login-info {
  padding-left: 140px;
}

.login-info-title {
  line-height: 90px;
  color: rgb(52, 58, 64);
}

.login-info-item {
  font-size: 14px;
  line-height: 2.5;
  color: rgb(33, 37, 41);
}

.login-border {
  width: 50%;
  float: left;
  box-sizing: border-box;
}

.login-main {
  margin: 0 auto;
  width: 50%;
  box-sizing: border-box;
}

.login-main>h3 {
  margin-bottom: 20px;
}

.login-main>p {
  color: #76838f;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 500;
  font-size: 22px;
  text-align: center;
  letter-spacing: 4px;
}

.login-menu {
  width: 100%;
  text-align: center;

  a {
    color: rgb(153, 153, 153);
    font-size: 12px;
    margin: 0px 8px;
  }
}

.login-index {
  margin-top: 40px !important;
  width: 180px;
  height: 48px;
  text-align: center;
  border-radius: 50px !important;
  background: transparent !important;
  color: #333 !important;
  font-size: 16px !important;
  border: 1px solid rgb(152, 22, 244);
}

.login-submit {
  display: block !important;
  margin: 40px auto 10px auto !important;
  width: 200px;
  height: 48px;
  font-size: 14px !important;
  text-align: center;
  border-radius: 50px !important;
  border: 0px;
  box-shadow: rgba(152, 22, 244, 0.19) 0px 5px 10px 2px;
}

.login-form {
  margin: 10px 0;

  i {
    color: #999;
  }

  .el-form-item__content {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 12px;
  }

  .el-input {
    input {
      padding-bottom: 10px;
      text-indent: 5px;
      background: transparent;
      border: none;
      border-radius: 0;
      color: #333;
      border-bottom: 1px solid rgb(235, 237, 242);
    }

    .el-input__prefix {
      i {
        padding: 0 5px;
        font-size: 16px !important;
      }
    }
  }
}

.login-code {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 0 0 10px;
}

.login-code-img {
  margin-top: 2px;
  width: 100px;
  height: 38px;
  background-color: #fdfdfd;
  border: 1px solid #f0f0f0;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 5px;
  line-height: 38px;
  text-indent: 5px;
  text-align: center;
}

.login-select {
  input {
    color: #333;
    font-size: 18px;
    font-weight: 400;
    border: none;
    text-align: center;
  }
}
</style>